import type { Routes } from '@angular/router';

export const USERS_ROLES_ROUTES: Routes = [
    {
        path: '',
        pathMatch: 'full',
        loadComponent: () =>
            import('#modules/user/views/restaurant-users/restaurant-users.component').then((m) => m.RestaurantUsersComponent),
    },
];
